import React, { useMemo } from 'react';
import { ChannelConnectionProps } from '../ChannelConnection';
import { useShowErrorMessage } from '../../../../../../handlingErrors';
import { useCurrentStateByControlUnitId } from '../../../../../../redux/controlUnit/hooks/useCurrentStateByControlUnitId';

function useChannelSetPoint(props: ChannelConnectionProps) {
  const { channel } = props;
  const showErrorMessage = useShowErrorMessage();
  const {
    channel: channelId = '',
    controlUnitId = '',
    deviceId: commanderId = '',
  } = channel || {};

  const { setPoints, loading } = useCurrentStateByControlUnitId(
    commanderId,
    controlUnitId,
    showErrorMessage
  );

  const setPoint = useMemo(
    () => setPoints?.find((setPoint) => setPoint.parameter?.name === channelId),
    [setPoints, channelId]
  );
  // TODO: round and convert to unit preferred
  const setPointValue = setPoint?.parameter?.value;
  const setPointUnit =
    setPoint?.parameter?.unitString ?? setPoint?.parameter?.unit ?? '';

  return {
    value: setPointValue,
    valueString: setPointValue && setPointValue.toString(),
    unit: setPoint?.parameter?.unit,
    unitString: setPointUnit,
    loading: loading && setPointValue == undefined,
    setPoint: setPoint,
    error: undefined,
    name: channel?.name,
    decimals: setPoint?.parameter?.decimals,
  };
}

export default useChannelSetPoint;
